import { render, staticRenderFns } from "./RecentlyActivity.vue?vue&type=template&id=d442e6c2"
import script from "./RecentlyActivity.vue?vue&type=script&lang=ts"
export * from "./RecentlyActivity.vue?vue&type=script&lang=ts"
import style0 from "./RecentlyActivity.vue?vue&type=style&index=0&id=d442e6c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports